// NOTE (internal): Boilerplate legal copy — same status as the other Legal pages.
// Requires attorney review before being treated as final. Do NOT represent to end users as legally reviewed.
import { Link } from "react-router-dom";
import { useEffect } from "react";
import Seo from "@/components/Seo";

const UPDATED = "June 2026";

const PARAGRAPHS = [
  "The content on Voluntold \u2014 including articles, tools (Coach Readiness Assessment, Practice Plan Generator, Parent Conversation Script Builder), and responses from Scout, our AI assistant \u2014 is provided for general informational and educational purposes only. It is based on personal coaching experience and is not a substitute for professional advice.",
  "Voluntold is not a licensed medical, mental health, psychological, or child development service. Nothing on this site should be interpreted as a diagnosis, treatment, or professional recommendation. If you or someone you coach is struggling with a mental health concern, please consult a licensed professional or contact a crisis line.",
  "Scout is an AI-generated assistant. Its responses are generated automatically and, while reviewed for general accuracy, may not always be complete, current, or applicable to your specific situation. Use your own judgment before acting on any recommendation.",
  "Results from any toolkit, program, or resource will vary based on individual effort, circumstances, and the athletes/teams involved. We make no guarantees of outcomes.",
  "Voluntold may reference or link to third-party sites, organizations, or products (including ChalkOS). We do not control and are not responsible for their content or practices.",
];

export default function Disclaimer() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-12" data-testid="legal-disclaimer">
      <Seo title="General Disclaimer" description="General informational and educational disclaimer for Voluntold's articles, tools, and Scout AI assistant." path="/disclaimer" />
      <span className="kicker">Legal</span>
      <h1 className="mt-2 font-head font-semibold uppercase text-4xl lg:text-5xl text-[#1E1E1E] leading-[1.05]">General Disclaimer</h1>
      <p className="mt-3 text-sm text-[#6E6E6E]">Last updated: {UPDATED}</p>

      <div className="mt-8 space-y-6">
        {PARAGRAPHS.map((p, i) => (
          <p key={i} className="text-[#1E1E1E] leading-relaxed text-[15px]">{p}</p>
        ))}
      </div>

      <div className="mt-12 border-t border-[#D3CFC0] pt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        <Link to="/legal/terms" className="text-[#2D2D2D] link-line">Terms</Link>
        <Link to="/legal/privacy" className="text-[#2D2D2D] link-line">Privacy</Link>
        <Link to="/legal/refund" className="text-[#2D2D2D] link-line">Refunds</Link>
        <Link to="/legal/cookies" className="text-[#2D2D2D] link-line">Cookies</Link>
        <Link to="/disclaimer" className="text-[#2D2D2D] link-line">Disclaimer</Link>
      </div>
    </div>
  );
}
